
Checkout.Cart.Item = function(checkout, cart) {
	var item = this;

    this.cartItemKey =
	this.productID =
	this.unitprice =
	this.data =
	this.$row =
	this.$content =
	this.$loadingOverlay =
	this.$loadingMsg =
	this.$removeOverlay =
	this.$error =
	this.$errorMsg =
	this.$warning =
	this.$warningMsg =
	this.$info =
	this.$infoMsg =
	this.$moreInfo =
	this.$moreInfoButton =
	this.$moreInfoContainer =
	this.moreInfoRequest
	this.moreInfoShown =
	this.$optionContainer =
	this.$contentTmpl =
	this.$contentsTitle =
		false;

	this.init = function() {
		item.$row = cart.$itemTpl.clone(true).attr('id', '');

		item.$content = item.$row.find('.cart-item-content');
		item.$loadingOverlay = item.$row.find('.loading-overlay');
		item.$loadingMsg = item.$loadingOverlay.find('.msg-text');
		item.$removeOverlay = item.$row.find('.confirm-remove');
		item.$error = item.$row.find('.cart-item-error');
		item.$errorMsg = item.$error.find('.msg-text');
		item.$warning = item.$row.find('.cart-item-warning');
		item.$warningMsg = item.$warning.find('.msg-text');
		item.$info = item.$row.find('.cart-item-info');
		item.$infoMsg = item.$info.find('.msg-text');
		item.$moreInfo = item.$row.find('.cart-item-moreinfo');
		item.$moreInfoButton = item.$row.find('.cart-item-moreinfo-button');
		item.$moreInfoContainer = item.$row.find('.cart-item-moreinfo-container');
		item.$editPriceWrap = item.$row.find('.cart-item-price-edit');
		item.$selectPrice = item.$row.find('.cart-item-price-edit select');
		item.$editPrice = item.$row.find('.cart-item-price-edit input');
		item.$displayPrice = item.$row.find('.cart-item-price');
		item.$optionContainer = item.$row.find('.selected_options');
		item.$contentsTitle = item.$row.find('.selected_opt_head');
		item.$contentsTmpl = item.$row.find('#tmpl-opt_list');

		if (checkout.user)
			item.$row.find('.cart-item-moreinfo-button').show();

		cart.$itemContainer.append(item.$row);

	};

	this.add = function(response) {
        var data        = response.item,
            infos       = response.infos,
            suggestions = response.suggestions,
            options     = response.kitContents || [];

		item.options = options;
		item.data = data;
        item.cartItemKey = data.cartItemKey;
		item.productID = data.productID;

		item.productPath = data.productPath;
		cart.items[item.cartItemKey] = item;

		item.$row.attr('id', 'cart-item-'+item.cartItemKey);
		item.$row.find('.cartDescLink').attr('href', fixNavState('/'+ item.productPath));

        // Determine whether or not to enable the "addToWishList" button
        if(data.inWishList) {
            item.$row.find(".cartatwl")
                .addClass("added")
                .addClass("wl-" + data.inWishList);
            disableAddedItems();
        }
        else {
            item.$row.find(".cartatwl").click(function() {
                if (data.pdk) {
                    window.getOptionString = function() {
                        return data.pdk;
                    }
                } else {
                    window.getOptionString = function(){};
                }
    		
		        item.$row.find(".cart-item-content").append(
	                $("<input>")
	                    .prop("type", "hidden")
	                    .prop("name", "qty_box1_" + data.productID)
	                    .addClass("qty tmpQty")
	                    .val(item.$row.find(".cart-item-qty").val())
	            );

                addToWishList(data.productID);
            });
        }
		if(data.pdk) {
			item.$row.addClass('pdkProduct');
			item.$contentsTitle.html('Selected Options');
		}
		if(data.kit) {
			item.$row.addClass('kitProduct');
			item.$contentsTitle.html('Kit Contents');
		}
		// Add any product suggestions to the list
		if(checkout.config.suggestions && suggestions && suggestions.length) {
			for(var i = 0; i < suggestions.length; i ++) {
				checkout.suggestions.addItem(suggestions[i]);
			}
		}
		if(options && options.length) {
			for(var i = 0; i < options.length; i ++) {
				new Checkout.Cart.Item.Option(item).add(options[i]);
			}
		}

		for (var k in item.data) {
			var $el = item.$row.find('.cart-item-'+k);
			
			// needed because shipETA is not set in time (via cart.setShipDate) for shipQuote call
			if (k == 'ETA') {
				if (item.data[k] > checkout.cart.shipETA)
					checkout.cart.shipETA = item.data[k];
			}
			
			if (!$el.length)
				continue;

			if (k == 'pretty_partnumber') {
				if (checkout.user)
					$el.html(
						'<a href="'+checkout.config.productAdminEditURL+item.data[checkout.config.cartItemProdIDKey]+'" target="_blank">'
							+ item.data[k]
						+ '</a>'
					);
				else
					$el.html(item.data[k]);
			} else if (k == 'qty')
				$el.val(item.data[k]);
			else if (k == 'pdk')
				$el.html(item.data[k]);
			else if (k == 'stockStatusIcon')
				$el.addClass('status-' + item.data[k]);
			else if (k == 'mainImage') {
				if (item.data.mainImage){
          var prodImgSize = pointsBreak.getWidth() > 480 ? checkout.config.prodImgSize.small : 300;
          prodImgSize !== undefined ? $el.attr('src', CDNproduct + '/' + item.data.mainImage + '_x'+prodImgSize+'.jpg') : $el.attr('src', CDNpath + '/img/bg_no-image_100x75.jpg');
        }

			} else if (k == 'brand') {
				if (item.data.brand)
					$el.attr({
						'src': CDNbrandLogo + '/img/brands/' + item.data.brand.name + '.gif',
						'width': item.data.brand.width,
						'height': item.data.brand.height,
						'alt': item.data.brand.name
					});
			} else if (k == 'shipfree') {
				if (parseInt(item.data.shipfree))
					$el.show();
			} else if (k == 'shipFreeEligible') {
				if (parseInt(item.data.shipFreeEligible))
					$el.show();
			} else if (k == 'groundshipOnly') {
				if (parseInt(item.data.groundshipOnly))
					$el.show();
			} else if (k == 'notifyMe') {
				if (parseInt(item.data.notifyMe)) {
					$el.find('a').attr('data-productid',item.data.productID);
					$el.find('a').css('cursor', 'pointer');
					$el.show();
				}
			} else if (k == "stockStatusLong") {
				$el.attr("data-content", item.data[k])
					.removeClass("disabled");
				//initStockStatusToolTips();
			} else if (k == "stockStatus") {
				if (item.data['stockStatusIcon'] === '1')
					$el.addClass('redtxt').html(item.data[k]);
				else
					$el.html(item.data[k]);
			} else
				$el.html(item.data[k]);
		}

		item.setPrice(item.data.unitprice, item.data.price_retail, item.data.availablePricing);
		item.updatePricingLevels();

		if (checkout.user)
			item.$row.find('.cart-item-pretty_partnumber')
				.css({ 'cursor': 'pointer'})
				.click(function() {

				});

		if (
			infos
			&& infos.length
		)
			item.info(infos.join('<br />'));
		else
			item.info(false);

		item.$content.show();
		return item;
	};

	this.changeQty = function(qty) {

		if (!qty) {
			cart.toggleStepControls(false);
			item.$removeOverlay.show();
			return;
		}

		if (qty == item.data.qty) {
			item.$row.find('.cart-item-qty').val(item.data.qty);
			return;
		}

		item.loading('Updating Item Quantity');
		cart.totals.loading('Calculating Totals');

		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'updateQty',
                'cartItemKey': item.cartItemKey,
				'productID': item.productID,
				'qty': qty,
				'pricing': (item.$selectPrice.val() || 'retail')
			}
		})
			.done(function(response) {
				item.error(false);
				item.warning(response.warning);
                if(response.notice) cart.error(response.notice);

				var qtyChanged = false;
				if (response.data.qty != item.data.qty)
					qtyChanged = true;

				item.update(response.data);

				if (qtyChanged) {
					cart.totals.calc(true);
				} else {
					cart.totals.update('cart');
				}
			})
			.fail(function(request) {
				item.error('Failed to Update Item Quantity');
				item.warning(false);
			})
			.always(function() {
				item.loading(false);
				item.$row.find('.cart-item-qty').focus();
			});
	};

	this.confirmRemove = function(remove) {
		if (remove)
			item.remove();
		else {

			if (checkout.session.get('step') == 'cart')
				cart.toggleStepControls();

			item.changeQty(item.data.qty);
			item.$removeOverlay.hide();
			item.$row.find('.cart-item-qty').focus();
		}
	};

	this.update = function(data, infos) {

		if (!infos) {
			infos = [];

			if (data.stockStatus != item.data.stockStatus)
				infos.push('The availability of this item has changed due to quantity on your order');

			if (data.unitprice != item.unitprice)
				infos.push('Price has changed');
		}

		item.data = data;

		item.$row.find('.cart-item-qty').val(item.data.qty);

		item.$row.find('.cart-item-stockStatusIcon')
			.attr('class', 'cart-item-stockStatusIcon')
			.addClass('status-'+item.data.stockStatusIcon);

		if (item.data.stockStatusIcon === '1') 
			item.$row.find('.cart-item-stockStatus').addClass('redtxt').html(item.data.stockStatus);
		else
			item.$row.find('.cart-item-stockStatus').removeClass('redtxt').html(item.data.stockStatus);

		item.updatePricingLevels();
		item.setPrice(data.unitprice, data.price_retail, data.availablePricing);

		if (infos.length)
			item.info(infos.join('<br />'));
		else
			item.info(false);

        cart.sendToListrak();
	};

	this.updatePricingLevels = function() {

		var $el = item.$row.find('.cart-item-shipFreeEligible');

		if ( parseInt(item.data.shipFreeEligible || 0) ) {
			$el.show();
		} else {
			$el.hide();
		}

		var pricing = item.data.availablePricing,
			pricingLevel = item.$selectPrice.val(),
			options = [];
//
//      The following test is replaced to take care of 'LimitedQty' and 'Retail' in
//      the pricing structure.  'Retail' would show to the customer.
//
//		if (
//			Object.keys(pricing).length <= 1
//			&& ('retail' in pricing)
//
//      Make sure 'Retail' is the only type of pricing in the structure
//
		if (('retail' in pricing) &&
				(!('group' in pricing) &&
                 !('employee' in pricing) &&
				 !('cost' in pricing)))
		{
			item.$editPriceWrap.hide();
			item.$selectPrice.empty();
			return;
		}

		if ('retail' in pricing) {

			options.push('<option value="retail">Retail: '+pricing.retail+'</option>');

			if (
				!pricingLevel
				&& item.unitprice == pricing.retail
			)
				pricingLevel = 'retail';
		}

		if ('group' in pricing) {
			for (var group in pricing.group) {
				options.push(
					'<option value="group'+group+'">'
						+ ((group == 'Fixed') ? '' : 'Group ') +group+': '
						+ pricing.group[group]
						+ ' ('+ item.getDiscountPercent(pricing.retail, pricing.group[group]) + ')'
					+'</option>'
				);

				if (
					!pricingLevel
					&& item.unitprice == pricing.group[group]
				)
					pricingLevel = 'group'+group;
			}
		}

		if ('employee' in pricing) {
			options.push(
				'<option value="employee">Employee: '+pricing.employee+' ('
					+item.getDiscountPercent(pricing.retail, pricing.employee)
				+')</option>'
			);

			if (
				!pricingLevel
				&& item.unitprice == pricing.employee
			)
				pricingLevel = 'employee';
		}

		if ('cost' in pricing) {
			options.push(
				'<option value="cost">Cost: '+pricing.cost+' ('
					+item.getDiscountPercent(pricing.retail, pricing.cost)
				+')</option>'
			);

			if (
				!pricingLevel
				&& item.unitprice == pricing.cost
			)
				pricingLevel = 'cost';
		}

		if (
			!pricingLevel
			|| pricingLevel == 'manual'
		) {
			options.push('<option value="manual">Manual Entry</option>');
			pricingLevel = 'manual'
		}

		item.$selectPrice
			.empty()
			.html(options.join("\n"))
			.val(pricingLevel);

		if (
			Object.keys(pricing).length <= 1
			&& ('manual' in pricing)
		)
			item.$selectPrice.hide();
		else
			item.$selectPrice.show();

		if ('manual' in pricing) {
			item.$displayPrice.hide();
			item.$editPrice.show();
		} else {
			item.$displayPrice.show();
			item.$editPrice.hide();
		}

		item.$editPriceWrap.show();
	};

	this.getDiscountPercent = function(retail, price) {
		return (((1 - (price / retail)) * -100).toFixed(1))+'%';
	};

	this.changePrice = function(changeMethod) {
		var pricing = item.data.availablePricing,
			pricingLevel = item.$selectPrice.val(),
			newPrice = 0,
			$manualOption = item.$row.find('.cart-item-price-edit select option[value=manual]');

		if (changeMethod == 'input') {

			newPrice = item.$editPrice.val();

			if (!$manualOption.length)
				item.$selectPrice.append(
					'<option value="manual">Manual Entry</option>'
				);

			item.$selectPrice.val('manual');

		} else {

			newPrice = pricing[pricingLevel];

			if ($manualOption.length)
				$manualOption.remove();

		}

		if (
			changeMethod == 'select'
			&& pricingLevel.substr(0, 5) == 'group'
		)
			newPrice = pricing.group[pricingLevel.substr(5)];

		newPrice = (parseFloat(newPrice) || 0).toMoney();

		if (item.unitprice != parseFloat(newPrice)) {

			item.loading('Updating Item Price');
			cart.totals.loading('Calculating Totals');

			checkout.remote.call({
				'data': {
					'step': 'cart',
					'action': 'updatePrice',
                    'cartItemKey': item.cartItemKey,
					'productID': item.productID,
					'qty': item.data.qty,
					'price': newPrice
				}
			})
				.done(function(response) {
					item.error(false);
					item.warning(response.warning);

					var valueChanged = false;
					if (response.data.unitprice != newPrice)
						valueChanged = true;

					item.setPrice(response.data.unitprice);

					if (valueChanged)
						cart.totals.calc(true);
					else
						cart.totals.update('cart');
					})
				.fail(function(request) {
					item.error('Failed to Update Item Price');
				})
				.always(function() {
					item.loading(false);
				});
		}
	};

	this.setPrice = function(price, retail, availablePricing) {
		item.unitprice = parseFloat(price);
		item.$row.find('.cart-item-price').html(item.unitprice.toMoney());
		item.$row.find('.cart-item-price-edit input').val(item.unitprice.toMoney());
		item.extendPrice();

		price  = parseFloat(price);
        retail = parseFloat(retail);

        if(price < retail) item.saleDiscount(price, retail, availablePricing);
	};

	this.extendPrice = function() {
		item.$row.find('.cart-item-extendprice').html(
			commaSeparate((item.data.qty * item.unitprice).toMoney())
		);
	};

	this.saleDiscount = function(price, retail, availablePricing) {
        var discountPercentage = (retail - price) / retail * 100;
        // round the discount to the nearest percent
        discountPercentage = parseInt(discountPercentage + 0.5, 10);

        item.$row.find(".pricecut").show()
            .html("$" + retail.toMoney());

        // Do not show the on sale text if this is a wholesale/manual price
        if(availablePricing
            && price != availablePricing.retail
            ) {
            return;
        }

        var saleText = "ON SALE";
        if(availablePricing.limitedQty) {
            saleText += " - Limited Qty";
        }
        else if(discountPercentage >= 10) {
            saleText += " - Save " + discountPercentage + "%";
        }

        item.$row.find(".onsale").show()
            .find("span").html(saleText);
    };

	this.remove = function() {

		if (!item.productID) {
			item.$row.remove();
			return;
		}

		item.loading('Removing Item');
		cart.totals.loading('Calculating Totals');

		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'remove',
				'cartItemKey' : item.cartItemKey
			}
		})
			.done(function() {
				item.$row.fadeOut(500, function() {
					item.$row.remove();
					delete(cart.items[item.cartItemKey]);
                    if (Object.keys(cart.items).length) {
                        cart.toggleHasContents(true);
                        cart.totals.calc(true);
                    } else {
                        cart.toggleHasContents(false);
                        cart.toggleStepControls(false);
                    }
					cart.totals.updateNumItems();
                    cart.sendToListrak();
				});
			})
			.fail(function(request) {
				var errorMsg = checkout.remote.getErrorMsg(request);

				item.loading(false);

				if (errorMsg)
					alert('Removing Cart Item Failed: ' + errorMsg);
			});
	};

	this.toggleMoreInfo = function() {

		if (item.moreInfoShown) {

			if (item.moreInfoRequest)
				item.moreInfoRequest.abort();

			if (!(checkout.config.isEndeca)) {
				item.$moreInfoButton
					.removeClass('btn-red')
					.addClass('btn-green');
			}

			item.$moreInfoButton.find('i')
				.removeClass('icon-minus-sign')
				.addClass('icon-plus-sign');

			item.$moreInfoButton.find('.msg-text')
				.html('More Info');

			item.$moreInfo.slideToggle();
			item.moreInfoShown = false;
		} else {

			if (item.moreInfoRequest)
				item.moreInfoRequest.abort();

			item.$moreInfoButton.find('.msg-text')
				.html('Loading More Info...');

			item.moreInfoRequest = checkout.remote.call({
				'data': {
					'step': 'cart',
					'action': 'getMoreInfo',
					'productID': item.productID,
					'qty': item.data.qty,
					'pdkStr': cart.items[item.cartItemKey].data.pdk
				}
			})
				.done(function(response) {

					var rows = [];

					$.each(response.data, function(i, product) {
						rows.push(item.buildMoreInfoRow(product));
					});

					item.$moreInfoContainer
						.empty()
						.append(rows);

					if (!(checkout.config.isEndeca)) {
						item.$moreInfoButton
							.removeClass('btn-green')
							.addClass('btn-red');
					}
					
					item.$moreInfoButton.find('i')
						.removeClass('icon-plus-sign')
						.addClass('icon-minus-sign');

					item.$moreInfoButton.find('.msg-text')
						.html('Hide More Info');

					item.$moreInfo.slideToggle();
					item.moreInfoShown = true;

				})
				.fail(function(request) {
					item.$moreInfoButton.find('.msg-text')
						.html('Error Loading More Info');
				});

		}
	};

	this.buildMoreInfoRow = function(product) {
		var $row = cart.$itemMoreInfoRowTpl.clone(true).attr('id', '');

		if (!(checkout.config.isEndeca)) {
			$row.find('.info-stockstatus').addClass('status-'+product.stockStatusCode);
		}
		$row.find('.pretty_stockstatus').html(product.stockStatus);

		$row.find('.productID')
			.attr('href', checkout.config.productAdminEditURL+product.productID)
            .attr('target', '_blank');

		if (product.tmsProductID)
			$row.find('.productID').html('T#'+ product.tmsProductID);
		else
			$row.find('.productID').html('ES#'+ product.productID);

		$row.find('.description').html(product.description);

		$row.find('.onhnd').html(product.onHand);
		$row.find('.onordr').html(product.quantity_ordered);
		$row.find('.cmmtd').html(product.committed);
		$row.find('.avlbl').html((product.onShelf - product.committed));

		if (product.sellingQty > (product.onShelf - product.committed))
			$row.find('.rqrd').html('<strong>'+product.sellingQty+'</strong>');
		else
			$row.find('.rqrd').html(product.sellingQty);

		return $row;
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			item.$loadingMsg.html(loadingMsg);
			item.$loadingOverlay.show();
			checkout.alignMiddle(item.$loadingOverlay.find('.msg'), item.$loadingOverlay);
			this.clearMessages();
		} else
			item.$loadingOverlay.hide();
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			item.$errorMsg.html(errorMsg);
			item.$error.show();
		} else {
			item.$error.hide();
			item.$errorMsg.html('');
		}
	};

	this.warning = function(warningMsg) {
		if (warningMsg) {
			item.$warningMsg.html(warningMsg);
			item.$warning.show();
		} else {
			item.$warning.hide();
			item.$warningMsg.html('');
		}
	};

	this.info = function(infoMsg) {
		if (infoMsg) {
			item.$infoMsg.html(infoMsg);
			item.$info.show();
		} else {
			item.$info.hide();
			item.$infoMsg.html('');
		}
	};
	
	this.clearMessages = function() {
		this.error();
		this.warning();
		this.info();
	}

	this.init();
};
